export class LanguageReferenceModel {
    public languageCode: string;
    public languageName: string;
    public primaryFlag: boolean;
    public sortSequence: number;
    public statusCode: string;
}